module.exports = __webpack_public_path__ + "static/media/28DGC2.88204ab8.jpg";